import BookLayout from './BookLayout';

export default BookLayout;
